import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BikeSearchPage } from 'PyzShopUi/scripts/bike-search-page/components/BikeSearchPage';
import { API_URL, FILTER_TYPE_MAPPING, VIEW_MODE_AVAILABLE_OPTIONS } from 'PyzShopUi/scripts/bike-search-page//constants';
import FilterStateService from 'PyzShopUi/scripts/shop-ui/components/search-page/services/FilterStateService';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import IReactEvent from 'PyzShopUi/scripts/interfaces/article-list/IReactEvent';
import { ISearchPageContentDataUpdatedPayload } from 'PyzShopUi/scripts/shop-ui/components/search-page/interfaces';
import { SearchPageEvent } from 'PyzShopUi/scripts/shop-ui/components/search-page/events/searchPageEvent';
import { IBikesList } from 'PyzShopUi/scripts/bike-search-page/interfaces';
import { VIEW_MODE_GRID, VIEW_MODE_LIST } from 'PyzShopUi/scripts/shop-ui/components/search-page/constants';
import BikeGrid from 'PyzShopUi/scripts/bike-search-page/components/search-page-content/bike-list/BikeGrid';
import BikeList from 'PyzShopUi/scripts/bike-search-page/components/search-page-content/bike-list/BikeList';
import Loading from 'PyzShopUi/scripts/react/common/components/Loading';
import { IBikeItem } from 'PyzShopUi/scripts/bike/interfaces';
import Component from 'ShopUi/models/component';

class BikeSearchPageHandler extends Component {
    protected readyCallback(): void {
    }

    init = (): void => {
        const bikeSearchPageElement: HTMLElement = document.querySelector('.bike-search-page-client-init');
        if (!bikeSearchPageElement) {
            return;
        }

        const bikeSearchPageElementRoot = createRoot(bikeSearchPageElement);

        const defaultParameter = bikeSearchPageElement.dataset.defaultParameters ? JSON.parse(bikeSearchPageElement.dataset.defaultParameters) : {};
        const csrfToken = bikeSearchPageElement.dataset.csrfToken;
        const filterStateService = new FilterStateService(FILTER_TYPE_MAPPING);
        const resultsContainer: HTMLElement = document.querySelector('.bike-search-results');
        const resultsContainerRoot = createRoot(resultsContainer);
        if (!VIEW_MODE_AVAILABLE_OPTIONS.includes(defaultParameter.viewMode)) {
            defaultParameter.viewMode = VIEW_MODE_GRID;
        }

        bikeSearchPageElementRoot.render(
            <React.Suspense fallback={<Loading />}>
                <BikeSearchPage
                    apiUrl={API_URL}
                    defaultParameter={defaultParameter}
                    filterStateService={filterStateService}
                />
            </React.Suspense>);

        MiddlewareEventBus.getInstance().subscribe((event: IReactEvent<ISearchPageContentDataUpdatedPayload>) => {
            if (event.type !== SearchPageEvent.SEARCH_PAGE_CONTENT_DATA_UPDATED) {
                return;
            }

            if (event.payload.isSearchPageLoading) {
                resultsContainerRoot.render(
                    <Loading />);

                return;
            }

            if (!event.payload.hasFiltersSelected) {
                resultsContainerRoot.render(
                    <BikeGrid
                        hasSideBar={true}
                        bikes={event.payload.searchResultItems as IBikeItem[]}
                        csrfToken={csrfToken}
                    />);

                return;
            }

            if (event.payload.viewMode === VIEW_MODE_LIST) {
                resultsContainerRoot.render(
                    <BikeList
                        bikeLists={event.payload.searchResultItems as IBikesList[]}
                    />);

                return;
            }

            if (event.payload.viewMode === VIEW_MODE_GRID) {
                resultsContainerRoot.render(
                    <BikeGrid
                        hasSideBar={true}
                        bikes={event.payload.searchResultItems as IBikeItem[]}
                        csrfToken={csrfToken}
                    />);

                return;
            }
        });
    }
}

export default BikeSearchPageHandler;
